// extracted by mini-css-extract-plugin
export var animate1 = "Button-module--animate1--ulM1h";
export var animate2 = "Button-module--animate2--Tprmo";
export var gray = "Button-module--gray--8ehpP";
export var large = "Button-module--large--Xkfhq";
export var root = "Button-module--root--a0Hzn";
export var transparent = "Button-module--transparent--+R+jw";